import { configureStore } from "@reduxjs/toolkit";
import dsLayoutReducer from "./reducer/dsLayoutMode";
import requestStatusSlice from "./reducer/requestStatusSlice";
import notificationSlice from "./reducer/notificationSlice";
import uiCommandSlice from "./reducer/uiCommandSlice";
import plantSlice from "./reducer/plantSlice";

export const appStore = configureStore({
    reducer:{
        dsLayout:dsLayoutReducer,
        request:requestStatusSlice,
        notification:notificationSlice,
        uiCommand:uiCommandSlice,
        plant:plantSlice
    }
});

export type RootState = ReturnType<typeof appStore.getState>;